<template lang="pug">
  app-modal(
    title="Atenção",
    :visible.sync="isVisible",
    :width="600",
    @closeModal="beforeClose()",
  )
    template(slot="body").body
      validation-observer(ref='validation' tag='form')
        el-row.info
          el-col(:span="2")
            i.fa.fa-exclamation-circle.fa-2x
          el-col(:span="21", style="margin-left: 2%; margin-top: -2%").alerts
            span(v-if="sIndireta") Após a ação, o processo será encaminhado para caixa de suspensão e será submetido a avaliação do Coordenador.
            br
            span(v-if="sIndireta") Deseja continuar?
            span(v-if="msgAprovacao") Deseja aprovar a suspensão do processo?
            span(v-if="msgSuspensao") Deseja suspender o processo?
            span(v-if="isCancelamento") Deseja cancelar a suspensão do processo?
        el-row(justify="space-between")
          el-col(:span="19")
            Label(label="Justificativa:")
          el-col(:span="5" class="text-right")
            el-button(type="primary", @click="openModalJustificativa").btn-modelo Modelo &nbsp
              .fa.fa-file.icon-file
        validation-provider(rules="required", v-slot="{ errors }")
          app-editor-texto-modal(
            @onTextChange="onTextChange",
            :value="dadosSuspensao.justificativa",
            :class="{'erro' : errors.length}"
            ref="editorTexto"
          )
          span.help.erro {{ errors[0] }}
          app-modal-selecionar-modelo-notificacao(
            :tiposModelo="[7]",
            :titulo="tituloModalModelo",
            :idProcesso="idProcesso",
            v-if="showModalDespacho",
            :showModal="showModalDespacho"
            @closeModal="fecharModalJustificativa",
            @setTextoJustificativa="setTextoJustificativa"
          )
    template(slot="footer")
      span(slot="footer" :class="isBotaoUnicoSetClass ? 'button-aprove' : 'buttons'")
        el-button.btn(
            v-if="isReprovacao",
            type="default"
            @click="reprovarSuspensao()"
          )
          span.center
            i.fa.fa-times
            b.msg Reprovar suspensão
        el-button(
          v-if="!isCancelamento"
          type="primary",
          @click="aprovarSuspensao()"
        )
          span.center
            i.fa.fa-check
            b.msg {{ sIndireta ? 'Solicitar suspensão' : msgAprovacao ? 'Aprovar suspensão' : 'Suspender processo' }}
        el-button(
          v-if="isCancelamento"
          type="primary",
          @click="cancelarSuspensao()"
        )
          span.center
            i.fa.fa-ban
            b.msg Cancelar suspensão
</template>

<script>
import { AppModal, Label, Divider } from 'sicarf-components'
import AppModalSelecionarModeloNotificacao from '@/screens/analise/components/AppModalSelecionarModeloNotificacao'
import AppEditorTextoModal from '@/components/AppEditorTextoModal'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import status from '@/constants/ap/dadosEstado/suspensao'
import { mapGetters, mapActions } from 'vuex'

export default {

  components: {
    AppModal,
    Label,
    Divider,
    AppModalSelecionarModeloNotificacao,
    AppEditorTextoModal
  },

  mixins: [
    AppNotificacao
  ],

  data () {
    return {
      dialogVisible: false,
      tituloModalModelo: 'Modelos de Justificativa',
      showModalDespacho: false,
      dadosSuspensao: {
        idProcesso: this.idProcesso,
        setorAnteriorSuspensao: this.setor,
        justificativa: '',
        statusSuspensao: status.SOLICITACAO
      },
      suspensaoIndireta: this.sIndireta
    }
  },

  props: {
    idProcesso: {
      type: Number,
      require: true
    },
    numeroProcesso: {
      type: String,
      require: true
    },
    setor: {
      type: String,
      require: true
    },
    sIndireta: {
      type: Boolean,
      require: true
    },
    isCancelamento: {
      type: Boolean
    },
    caixaSuspensao: {
      type: Boolean,
      require: true
    }
  },

  computed: {
    ...mapGetters({
      isVisible: 'dialog/isVisible'
    }),
    isReprovacao () {
      return this.caixaSuspensao && !this.isCancelamento
    },
    isBotaoUnicoSetClass () {
      return (!this.sIndireta && this.caixaSuspensao && !this.isReprovacao) ||
      this.isCancelamento ||
      (!this.sIndireta && !this.caixaSuspensao) ||
      (this.sIndireta && !this.caixaSuspensao)
    },
    msgSuspensao () {
      return !this.sIndireta && !this.isCancelamento && !this.caixaSuspensao
    },
    msgAprovacao () {
      return !this.sIndireta && !this.isCancelamento && this.caixaSuspensao
    }
  },

  async mounted () {
    this.dialogVisible = true
  },

  methods: {
    ...mapActions({
      setVisible: 'dialog/setVisible',
      findJustificativasByIdUsuario: 'modelo/findJustificativasByIdUsuario',
      suspender: 'despacho/criarDespachoSuspensaoProcesso'
    }),

    closeModal () {
      this.$emit('closeModal')
    },

    beforeClose () {
      this.setVisible(false)
      this.closeModal()
    },

    onTextChange (text) {
      this.dadosSuspensao.justificativa = text
    },

    async aprovarSuspensao () {
      const valido = await this.$refs.validation.validate()
      if (valido) {
        const tipo = this.sIndireta ? status.SOLICITACAO : status.APROVADA
        const notificacao = this.sIndireta ? 'Processo enviado para análise de suspensão' : 'Processo suspenso com sucesso'
        const texto = this.sIndireta ? `Tem certeza que deseja solicitar a suspensão do Processo n° ${this.numeroProcesso}?`
          : `Tem certeza que deseja realizar a suspensão do Processo n° ${this.numeroProcesso}?`
        this.mensagemAlertaDinamica(texto, tipo, notificacao)
      }
    },

    async reprovarSuspensao () {
      const valido = await this.$refs.validation.validate()
      if (valido) {
        const notificacao = 'Processo retornado com sucesso'
        const texto = `Tem certeza que deseja reprovar solicitação de suspensão do Processo n° ${this.numeroProcesso}?`
        this.mensagemAlertaDinamica(texto, status.REPROVADA, notificacao)
      }
    },

    async cancelarSuspensao () {
      const valido = await this.$refs.validation.validate()
      if (valido) {
        const notificacao = 'Processo retornado com sucesso'
        const texto = `Tem certeza que deseja cancelar a suspensão do Processo n° ${this.numeroProcesso}?`
        this.mensagemAlertaDinamica(texto, status.CANCELADA, notificacao)
      }
    },

    mensagemAlertaDinamica (texto, tipo, notificacao) {
      this.$confirm(
        texto,
        'Atenção',
        {
          confirmButtonText: 'Confirmar',
          cancelButtonText: 'Cancelar',
          type: 'warning'
        }
      )
        .then(async () => {
          switch (tipo) {
            case 'APROVADA':
              this.dadosSuspensao.statusSuspensao = status.APROVADA
              await this.suspender(this.dadosSuspensao)
              this.showNotificacao(
                this.$messages.TIPO_SUCCESS,
                this.$messages.TITULO_SUCCESS,
                notificacao
              )
              this.setVisible(false)
              this.closeModal()
              this.$emit('refresh')
              break

            case 'REPROVADA':
              this.dadosSuspensao.statusSuspensao = status.REPROVADA
              await this.suspender(this.dadosSuspensao)
              this.showNotificacao(
                this.$messages.TIPO_SUCCESS,
                this.$messages.TITULO_SUCCESS,
                notificacao
              )
              this.setVisible(false)
              this.closeModal()
              this.$emit('refresh')
              break

            case 'CANCELADA':
              this.dadosSuspensao.statusSuspensao = status.CANCELADA
              await this.suspender(this.dadosSuspensao)
              this.showNotificacao(
                this.$messages.TIPO_SUCCESS,
                this.$messages.TITULO_SUCCESS,
                notificacao
              )
              this.setVisible(false)
              this.closeModal()
              this.$emit('refresh')
              break

            case 'SOLICITACAO':
              this.dadosSuspensao.statusSuspensao = status.APROVADA
              await this.suspender(this.dadosSuspensao)
              this.showNotificacao(
                this.$messages.TIPO_SUCCESS,
                this.$messages.TITULO_SUCCESS,
                notificacao
              )
              this.setVisible(false)
              this.closeModal()
              this.$emit('refresh')
              break
          }
        })
    },

    openModalJustificativa () {
      this.showModalDespacho = true
    },

    fecharModalJustificativa () {
      this.showModalDespacho = false
    },

    setTextoJustificativa (textoJustificativa) {
      this.dadosSuspensao.justificativa = textoJustificativa
    }
  }
}

</script>

<style lang="scss" scoped>
@import "@/assets/styles/element-variables.scss";

.fa-exclamation-circle {
  color: #f1b55b;
  display: flex;
  align-items: center;
}

.info {
  width: 100%;
  margin-bottom: 5%;
}

::v-deep .el-col-2 {
  display: flex;
  justify-content: center;
  align-items: center !important;
}

.align-end {
  display: flex;
  justify-content: flex-end;
}

.icon-file {
  margin-left: 2px;
}

.btn-modelo {
  margin-bottom: 10px;
  margin-left: 5px;
}

.buttons {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0;
}

.button-aprove {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 0;
}

.msg {
  margin-left: 4px;
}

.alerts span {
  color: #909399 !important
}

</style>



// WEBPACK FOOTER //
// src/components/ModalSuspensaoProcesso.vue